// Include bootstrap JS only 
if (process.browser) {
  require('bootstrap')
}